import { Box, CircularProgress, Typography } from '@mui/material';
import { useState } from 'react';
import { ThreadMediaType } from '../database/forum';
import AudioPlayer from '../bts/components/audio/AudioPlayer';
import VideoPlayer from '../bts/components/video/VideoPlayer';

interface ThreadMediaProps {
    mediaUrl: string;
    mediaType: ThreadMediaType;
    maxWidth?: string;
    maxHeight?: string;
}

const ThreadMedia: React.FC<ThreadMediaProps> = ({
    mediaUrl,
    mediaType,
    maxWidth = '100%',
    maxHeight = '400px',
}) => {
    const [mediaLoading, setMediaLoading] = useState(true);
    const [mediaError, setMediaError] = useState(false);

    switch (mediaType) {
        case ThreadMediaType.IMAGE:
            return (
                <Box sx={{ mt: 2, maxWidth, position: 'relative' }}>
                    {mediaLoading && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: '200px',
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    )}
                    <img
                        src={mediaUrl}
                        alt='Thread media'
                        style={{
                            maxWidth: '100%',
                            maxHeight,
                            borderRadius: '8px',
                            objectFit: 'contain',
                            display: mediaLoading ? 'none' : 'block',
                        }}
                        onLoad={() => setMediaLoading(false)}
                        onError={(e) => {
                            console.error('Failed to load image: ', e);
                            setMediaLoading(false);
                            setMediaError(true);
                        }}
                    />
                    {mediaError && (
                        <Typography color='error' variant='body2'>
                            Failed to load image
                        </Typography>
                    )}
                </Box>
            );
        case ThreadMediaType.VIDEO:
            return (
                <Box sx={{ mt: 2, maxWidth, position: 'relative' }}>
                    <VideoPlayer src={mediaUrl} />
                </Box>
            );
        case ThreadMediaType.AUDIO:
            return (
                <Box sx={{ mt: 2, width: '100%', position: 'relative' }}>
                    <AudioPlayer src={mediaUrl} />
                </Box>
            );
        default:
            return null;
    }
};

export default ThreadMedia;
